// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabActivitiesDragHandle-moduleRequestProfileTabActivitiesDragHandle__t8gKJ";
export { _1 as "RequestProfileTabActivitiesDragHandle" }
